import React from "react";
import {useTranslation} from "react-i18next";
import Header from "./Header";
import {ExitIcon} from "../icons/ExitIcon";
import {Button} from "@nextui-org/react";
import {useDispatch} from "react-redux";
import {sendEvent, setCloseInitiated} from "../../store/verification.slice";
import {trackEvent} from "../../utils/analytics";

function ClosePrompt({verification}) {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const exit = () =>{
        dispatch(setCloseInitiated(false))
        trackEvent("sdk_closed", {
            flowId: verification?.flowId,
            verificationId: verification?.verificationId,
            identityId: verification?.identityId
        })
        dispatch(sendEvent({
            type: "verificationExited",
            details: {
                verificationId: verification?.verificationId,
                identityId: verification?.identityId
            }
        }))
    }
    const continueVerification = () =>{
        dispatch(setCloseInitiated(false))
    }
    return (
        <div className="flex flex-col w-full h-full">
            <Header closeEnabled={false}/>
            <div className="flex flex-col p-4 gap-10 w-full h-full">
            <div className="mb-5 text-center">
                <div className="heading text-lg">{t("common.closePrompt.heading")}</div>
                <div className="text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("common.closePrompt.subheading")}</div>
            </div>
            <div className="flex flex-grow items-center justify-center">
                <ExitIcon height={150} width={150}/>
            </div>
            <div className="flex flex-col items-center gap-3">
                <Button radius="sm" color="primary" className="w-full" onClick={() => continueVerification()}>
                    {t("common.closePrompt.continue")}
                </Button>
                <Button radius="sm" variant="light" color="danger" className="w-full" onClick={() => exit()}>
                    {t("common.closePrompt.exit")}
                </Button>
            </div>
            </div>
        </div>

    );
}

export default ClosePrompt;
